import { createContext } from 'react';

import { Main } from './main-store';

export const rootStoreContext = createContext({
  MainStore: new Main(),
});
